/**
 * API layer xác thực — gọi các endpoint auth qua apiClient.
 *
 * Bao gồm: đăng ký, đăng nhập (email/Google/Apple), đăng xuất,
 * lấy/cập nhật hồ sơ, upload avatar.
 */
import { apiClient } from '../../../shared/services/apiClient';
import { API_ROUTES } from '../../../shared/constants/apiRoutes';

/**
 * Tập hợp các hàm gọi API xác thực và quản lý hồ sơ người dùng.
 * @type {{
 *   register: Function,
 *   login: Function,
 *   loginWithGoogle: Function,
 *   loginWithApple: Function,
 *   logout: Function,
 *   getCurrentUser: Function,
 *   updateProfile: Function,
 *   updateAvatar: Function,
 * }}
 */
export const authApi = {
  register: (registrationPayload) => apiClient.post(API_ROUTES.authRegister, registrationPayload),
  login: (credentials) => apiClient.post(API_ROUTES.authLogin, credentials),
  loginWithGoogle: (payload) => apiClient.post(API_ROUTES.authGoogle, payload),
  loginWithApple: (payload) => apiClient.post(API_ROUTES.authApple, payload),
  logout: () => apiClient.post(API_ROUTES.authLogout),
  getCurrentUser: () => apiClient.get(API_ROUTES.authMe),
  updateProfile: (profilePayload) => apiClient.put(API_ROUTES.authMe, profilePayload),
  updateAvatar: (avatarFormData) =>
    apiClient.post(API_ROUTES.authAvatar, avatarFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }),
};
